var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12 col-md-6" }, [
      _c("h2", [_vm._v(_vm._s(_vm.legalMentions.guaranteeTitle))]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-12 col-md-6",
        attrs: { id: "anchor-guarantee-legal-mentions" },
      },
      [
        _c("p", {
          staticClass: "mb-1",
          domProps: { innerHTML: _vm._s(_vm.legalMentions.guaranteeText) },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }